import { zUsdCents } from "@redotech/money/usd-amounts";
import * as z from "zod";

const updateUsageBillingSettings = z.object({
  kind: z.literal("usage"),
  enabled: z.boolean(),
  startDate: z.date().optional(),
  pricePerOrderInCents: z.number(),
  billIntentActiveOrders: z.boolean().optional(),
  billIntentAttributedOrdersPercent: z.number().gt(0).lte(100).optional(),
});
export type UpdateConversionUsageBillingSettings = z.infer<
  typeof updateUsageBillingSettings
>;

const updateSubscriptionBillingSettings = z.object({
  kind: z.literal("subscription"),
  enabled: z.boolean(),
  startDate: z.date().optional(),
  periodFeeInCents: zUsdCents,
  pricePerOrderInCents: zUsdCents.optional(),
  billIntentActiveOrders: z.boolean().optional(),
  billIntentAttributedOrdersPercent: z.number().gt(0).lte(100).optional(),
});
export type UpdateConversionSubscriptionBillingSettings = z.infer<
  typeof updateSubscriptionBillingSettings
>;

export const updateConversionBillingSettings = {
  name: "updateConversionBillingSettings" as const,
  input: z.object({
    teamId: z.string(),
    checkoutOptimizationBilling: z.union([
      updateUsageBillingSettings,
      updateSubscriptionBillingSettings,
    ]),
  }),
  output: z.null(),
};
